import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
// 使用数据持久化插件
pinia.use(piniaPluginPersistedstate)
/**
 * 安装Pinia
 * @param app vue实例
 */
export const setupStore = (app) => {
  app.use(pinia)
}
